import React from 'react'

import { TH, TD, Wrapper, WrapperTable, WrapperCol } from './styles'
import { ArticleTableProps } from './types'

export function ArticleTable({ config, marginTop }: ArticleTableProps) {
  return (
    <Wrapper marginTop={marginTop}>
      <WrapperTable>
        <colgroup>
          {config.colorColumnBody.map((item: string) => (
            <WrapperCol key={item} color={item} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {config.head.map(row => (
              <TH key={row[0]} colors={config.colorColumnHead}>
                {row}
              </TH>
            ))}
          </tr>
        </thead>
        <tbody>
          {config.body.map((item, index) => (
            <tr key={index}>
              {item.map((row, index) => (
                <TD key={index}>{row}</TD>
              ))}
            </tr>
          ))}
        </tbody>
      </WrapperTable>
    </Wrapper>
  )
}
